import { useT } from '../../i18n';
import { HEALTH_TITLE_KEY, milestoneHealth, type ExecutionHealth, type ExecutionHealthLevel } from '../../utils/executionHealth';
import { getExecutionProgress } from '../../utils/stages';

/**
 * A project's health, only while it is in Execution (as on the portfolio
 * cards): the PMO's manual status when set, else derived from the milestones.
 */
export function projectHealth(
  statusLabel: string | null,
  manual: ExecutionHealthLevel | null,
  milestones: { status?: string; estimated_end?: string | null; name?: string }[],
): ExecutionHealth | null {
  if (getExecutionProgress(statusLabel || '') !== 'execution') return null;
  const derived = milestoneHealth({ milestones });
  return manual ? { level: manual, milestone: manual === derived.level ? derived.milestone : undefined } : derived;
}

export const HEALTH_RANK: Record<ExecutionHealthLevel, number> = { red: 0, orange: 1, green: 2 };

export function HealthLabel({ health, compact = false }: { health: ExecutionHealth; compact?: boolean }) {
  const { t } = useT();
  return (
    <span className="home-health">
      <i className={`home-health-dot is-${health.level}`} aria-hidden="true" />
      <strong>{t(HEALTH_TITLE_KEY[health.level])}</strong>
      {!compact && health.milestone && <span className="home-meta">· {health.milestone}</span>}
    </span>
  );
}
